module.exports = __webpack_public_path__ + "pic/17.89afc8dc.png";